var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNegativeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.964,
    height: 22.964,
    viewBox: "0 0 22.964 22.964",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "circle-xmark-solid",
    d: "M11.482,22.964A11.482,11.482,0,1,0,0,11.482,11.482,11.482,0,0,0,11.482,22.964ZM7.849,7.849a1.072,1.072,0,0,1,1.52,0l2.108,2.108,2.108-2.108a1.075,1.075,0,0,1,1.52,1.52L13,11.477l2.108,2.108a1.075,1.075,0,0,1-1.52,1.52L11.477,13,9.369,15.106a1.075,1.075,0,0,1-1.52-1.52l2.108-2.108L7.849,9.369A1.072,1.072,0,0,1,7.849,7.849Z",
    fill: "#f82929"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNegativeIcon);
export default __webpack_public_path__ + "static/media/negative-icon.7aa1a99593e35c087f3a4b4183c8ec3e.svg";
export { ForwardRef as ReactComponent };